package top.wcpe.allincore.ui.runtime.canvas

import top.wcpe.allincore.ui.runtime.internal.concurrent.ConcurrentMutableMap

/**
 * 简单的日志去重限频器：相同 key 在窗口期内只放行一次。
 * 用于 canvas 渲染/解释期高频错误日志的抑制。线程安全。
 */
internal class LogThrottle(private val windowMs: Long) {

    private val lastLogged: ConcurrentMutableMap<String, Long> = ConcurrentMutableMap()

    /** 当前窗口内首次（或窗口已过）时返回 true 并刷新时间戳。 */
    fun allow(key: String, nowMs: Long): Boolean {
        val prev = lastLogged[key]
        if (prev == null || nowMs - prev >= windowMs) {
            lastLogged[key] = nowMs
            return true
        }
        return false
    }
}
